<template>
  <el-dialog title="群聊权限" :visible.sync="visible" width="680px" append-to-body>
    <el-alert title="以下限制仅针对普通成员，群主和群管理员不受限制。" type="info" :closable="false" class="policy-alert" />
    <el-form :model="form" label-width="145px" size="small">
      <el-row :gutter="16"><el-col v-for="x in switches" :key="x.key" :span="12"><el-form-item :label="x.label"><el-switch v-model="form[x.key]" :disabled="isForced(x.key)"/><div v-if="x.tip" class="policy-tip">{{ x.tip }}</div></el-form-item></el-col></el-row>
      <el-form-item label="链接发送规则"><el-select v-model="form.linkPolicy" :disabled="isForced('linkPolicy')"><el-option label="不限制链接" value="ALLOW_ALL"/><el-option label="禁止非白名单链接" value="WHITELIST_ONLY"/><el-option label="禁止所有链接（含白名单）" value="FORBID_ALL"/></el-select><div class="link-tip">白名单需在后台“群链接白名单”中维护。</div></el-form-item>
      <el-row :gutter="16">
        <el-col :span="12"><el-form-item label="普通成员撤回时限"><el-select v-model="form.memberRecallSeconds" :disabled="isForced('memberRecallSeconds')"><el-option label="2分钟" :value="120"/><el-option label="10分钟（默认）" :value="600"/><el-option label="不限制" :value="0"/></el-select></el-form-item></el-col>
        <el-col :span="12"><el-form-item label="成员撤回提示语"><el-input v-model="form.recallTip" :disabled="form.silentRecall || isForced('recallTip')" maxlength="100"/><div class="policy-tip">变量：{operator}</div></el-form-item></el-col>
        <el-col :span="12"><el-form-item label="管理撤回提示语"><el-input v-model="form.managerRecallTip" :disabled="form.silentRecall || isForced('managerRecallTip')" maxlength="100"/><div class="policy-tip">变量：{operator}、{sender}</div></el-form-item></el-col>
      </el-row>
      <el-row :gutter="16"><el-col :span="12"><el-form-item label="真实成员上限"><el-input-number v-model="form.memberLimit" :min="2" :max="3000" :disabled="isForced('memberLimit')"/></el-form-item></el-col><el-col :span="12"><el-form-item label="附加虚拟人数"><el-input-number v-model="form.virtualMemberCount" :min="0" :disabled="isForced('virtualMemberCount')"/></el-form-item></el-col></el-row>
      <el-form-item label="普通成员发言频率"><el-input-number v-model="form.rateLimitCount" :min="0" :disabled="isForced('rateLimitCount')"/><span class="gap">条 /</span><el-input-number v-model="form.rateLimitSeconds" :min="0" :disabled="isForced('rateLimitSeconds')"/><span class="gap">秒（0为不限）</span></el-form-item>
    </el-form>
    <template slot="footer"><el-button @click="visible=false">取消</el-button><el-button type="primary" :loading="saving" @click="save">保存</el-button></template>
  </el-dialog>
</template>
<script>
export default {
  name: 'GroupPolicyDialog',
  data() {
    return {
      visible: false,
      saving: false,
      form: {},
      switches: [
        { key: 'allowForward', label: '允许转发' },
        { key: 'allowImage', label: '允许发图片' },
        { key: 'allowVideoMessage', label: '允许发视频' },
        { key: 'allowVideoCall', label: '允许视频通话' },
        { key: 'allowAudio', label: '允许发语音' },
        { key: 'allowReceipt', label: '允许回执消息' },
        { key: 'allowCardMessage', label: '允许群内发送名片', tip: '包括个人名片和群名片。' },
        { key: 'allowMemberRecall', label: '允许普通成员撤回' },
        { key: 'allowMemberEdit', label: '允许普通成员编辑文字消息' },
        { key: 'allowMemberTopMessage', label: '允许普通成员置顶' },
        { key: 'allowMemberQuit', label: '允许成员主动退群' },
        { key: 'allowMemberAddFriend', label: '允许普通成员之间互加好友', tip: '关闭后仅禁止两个普通成员互加；普通成员可添加群主/管理员，群主/管理员也可添加普通成员。' },
        { key: 'showMemberList', label: '展示成员列表' },
        { key: 'showMemberAccount', label: '展示成员账号' },
        { key: 'silentKick', label: '踢人不通知' },
        { key: 'silentMute', label: '禁言不通知' },
        { key: 'silentRecall', label: '撤回不通知' }
      ]
    }
  },
  methods: {
    open(group) {
      this.visible = true
      const defaults = { allowMemberEdit: true, memberRecallSeconds: 600, recallTip: '{operator}撤回了一条消息', managerRecallTip: '{operator}撤回了{sender}的一条消息' }
      this.form = Object.assign({}, defaults, JSON.parse(JSON.stringify(group.policy || {})))
      this.$http({ url: `/group/policy/${group.id}`, method: 'GET' }).then(p => this.form = Object.assign({}, defaults, p))
    },
    isForced(key) {
      return (this.form.forcedFields || []).includes(key)
    },
    save() {
      this.saving = true
      this.$http({ url: '/group/policy', method: 'PUT', data: { ...this.form, groupId: this.form.groupId } })
        .then(p => {
          this.form = p
          this.$message.success('群聊权限已保存')
          this.$emit('saved', p)
          this.visible = false
        }).finally(() => this.saving = false)
    }
  }
}
</script>
<style scoped>.policy-alert{margin-bottom:16px}.gap{margin:0 8px;color:#909399}.link-tip,.policy-tip{color:#909399;font-size:12px;line-height:18px}</style>
